"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PasswordState_1 = require("./PasswordState");
/** Platform UI Components */
var Label_1 = require("@idp/ui-components/components/atoms/Label");
var TextField_1 = require("@idp/ui-components/components/atoms/TextField");
var TextFieldProps_1 = require("@idp/ui-components/components/atoms/TextField/TextFieldProps");
var Link_1 = require("@idp/ui-components/components/atoms/Link");
/** LOB Components */
var InlineError_1 = require("../../../common/InlineError/InlineError");
var StateProvider_1 = require("../../../../api/StateProvider");
var event_bus_1 = require("@idp/event-bus");
var ReportingService_1 = require("../../../../api/ReportingService");
var CommonFunctions_1 = require("../../../common/CommonFunctions/CommonFunctions");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
var globalStyles = require("../../../../styles/att-global.scss");
var inlineStyles = require("../../../common/InlineError/InlineError.scss");
var styles = require("../../../../styles/login-widget.scss");
var Password = /** @class */ (function (_super) {
    __extends(Password, _super);
    // private InlineErrorsCmsData: InlineErrorsCms;
    function Password(props) {
        var _this = _super.call(this, props) || this;
        _this.passwordEntryIsValid = false;
        _this.showPasswordCount = 0;
        _this.hidePasswordCount = 0;
        _this.commonFunctions = null;
        _this.state = new PasswordState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.initializeEvents();
        _this.backendErrorHandling = _this.backendErrorHandling.bind(_this);
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        return _this;
    }
    Password.prototype.componentWillReceiveProps = function (newProps) {
        // console.log('passwordIsInvalid =' + newProps.data.showPasswordInvalidError);
        // console.log('inlineErrors =' +  newProps.data.passwordErrorMessage);
        if (newProps.data.showPasswordInvalidError && !this.state.isPasswordinValid) {
            // console.log('newProps.passwordIsInvalid');
            this.setState({
                isPasswordinValid: newProps.data.showPasswordInvalidError,
                passwordErrTxt: this.PasswordCmsData.error.invalidPasswordText,
            });
        }
        if (this.commonFunctions.notBlankCheck(newProps.data.backendErrorMessage)) {
            this.setState({
                passwordValue: '',
            });
        }
    };
    Password.prototype.errorHandling = function () {
        var errorMessageEx = {
            eventHandler: this.backendErrorHandling,
            observerId: event_bus_1.ICCEventBusManager.getUUID(),
            serviceName: 'errorPassword',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(errorMessageEx);
    };
    Password.prototype.backendErrorHandling = function (data) {
        var _this = this;
        this.setState(function () {
            return {
                isPasswordinValid: true,
                passwordErrTxt: _this.PasswordCmsData.error.invalidPasswordText,
            };
        });
        // this.errorMsgFocus();
    };
    Password.prototype.initializeEvents = function () {
        var _this = this;
        // this.PasswordCmsData = CMS.get(new PasswordCms(), 'Password').content;
        // this.InlineErrorsCmsData = CMS.get(new InlineErrorsCms(), 'InlineErrors').content;
        this.PasswordCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        // events for password field
        this.passwordFieldEvents = {
            onBlur: function (value) {
                _this.passwordEntryIsValid = _this.validatePassword(value, '');
            },
            onChange: function (event) {
                _this.setState({
                    passwordValue: event.currentTarget.value,
                });
            },
            onClear: function (currentValue, e) {
                _this.setState({
                    passwordValue: '',
                }, function () {
                    _this.props.events.passwordReady(true, '', '');
                });
            },
            onKeyPress: function (value, event) {
                var keyCode = event.keyCode ? event.keyCode : event.which;
                var isShiftKey = event.shiftKey ? event.shiftKey : ((keyCode === 16) ? true : false);
                if (keyCode === 8 || keyCode === 32 || keyCode === 37 ||
                    keyCode === 38 || keyCode === 39 || keyCode === 40 ||
                    keyCode === 46) {
                    return;
                }
                if ((keyCode >= 65 && keyCode <= 90 && !isShiftKey) ||
                    (keyCode >= 97 && keyCode <= 122 && isShiftKey)) {
                    if (!_this.state.capsWarning) {
                        _this.setState({
                            capsWarning: true,
                            isPasswordinValid: true,
                            passwordErrTxt: _this.PasswordCmsData.error.capsLockWarningText,
                        }, function () {
                            _this.props.events.passwordReady(false, '', '');
                        });
                    }
                }
                else if (event.key === 'Enter') {
                    _this.validatePassword(value, event.key);
                }
                else {
                    _this.setState({
                        capsWarning: false,
                        isPasswordinValid: false,
                        passwordErrTxt: '',
                    });
                }
            },
        };
        // events for show hide password button
        this.showHidePasswordEvents = {
            onClick: function () {
                console.log('showHidePasswordEvents');
                if (!_this.state.showHidePasswordIsHidden) {
                    _this.hidePasswordCount = _this.hidePasswordCount + 1;
                    // no need to fire show and hide Password click Event
                    // this.reportingService.fireLinkClickEvent(LoginLinkNames.Hide_Password,
                    //    document.location.href);
                }
                else {
                    // no need to fire show and hide Password click Event
                    //    this.reportingService.fireLinkClickEvent(LoginLinkNames.Show_Password,
                    //        document.location.href);
                    _this.showPasswordCount = _this.showPasswordCount + 1;
                }
                /*
                const showPasswordCount =
                this.stateManager.get(getNamespace('LOGINUI'), 'showPasswordCount') as {showPasswordCount: number};
                const hidePasswordCount =
                this.stateManager.get(getNamespace('LOGINUI'), 'hidePasswordCount') as {hidePasswordCount: number};
                */
                _this.stateManager.set('showPasswordCount', { showPasswordCount: _this.showPasswordCount });
                _this.stateManager.set('hidePasswordCount', { hidePasswordCount: _this.hidePasswordCount });
                console.log('showHidePasswordEvents ' + _this.showPasswordCount + '##' + _this.hidePasswordCount);
                _this.setState({
                    showHidePasswordIsHidden: !_this.state.showHidePasswordIsHidden,
                });
            },
        };
    };
    Password.prototype.validatePassword = function (password, key) {
        var _this = this;
        var isValid = true;
        if (password === undefined || password === null || password.length === 0 ||
            password.length < 4) {
            isValid = false;
            this.setState({
                isPasswordinValid: true,
                passwordErrTxt: this.PasswordCmsData.error.invalidPasswordText,
            }, function () {
                _this.props.events.passwordReady(isValid, '', '');
            });
        }
        else {
            this.setState({
                isPasswordinValid: false,
                passwordErrTxt: '',
                passwordValue: password.trim(),
            }, function () {
                _this.props.events.passwordReady(isValid, password.trim(), key);
            });
        }
        return isValid;
    };
    Password.prototype.render = function () {
        var showHidePasswordElements = this.state.showHidePasswordIsHidden ?
            this.PasswordCmsData.loginWidget.showPasswordLinkText :
            this.PasswordCmsData.loginWidget.hidePasswordLinkText;
        var passwordFieldType = this.state.showHidePasswordIsHidden ? TextFieldProps_1.TextFieldType.PASSWORD : TextFieldProps_1.TextFieldType.TEXT;
        var passwordClass = [this.state.isPasswordinValid ? inlineStyles.showErrorMsg : ''];
        return (React.createElement("div", null,
            React.createElement("div", { className: [globalStyles.formRowXsm, passwordClass].join(' ') },
                React.createElement(Label_1.default, { data: {
                        text: this.PasswordCmsData.loginWidget.passwordLabel,
                    }, options: {
                        className: styles.inputLabel,
                    }, testId: 'LoginWidget_Label_Password' }),
                React.createElement(TextField_1.default, { data: { input: this.state.passwordValue }, options: {
                        type: passwordFieldType,
                    }, events: this.passwordFieldEvents, testId: 'LoginWidget_TextField_Password' }),
                React.createElement(InlineError_1.default, { data: { inlineErrorText: this.state.passwordErrTxt }, options: {
                        accessibilityText: this.PasswordCmsData.common.iconErrorAccessibilityText,
                    }, testId: 'LoginWidget_Inline_Error_Password' })),
            React.createElement("div", null,
                React.createElement(Link_1.default, { data: {
                        content: showHidePasswordElements,
                    }, events: this.showHidePasswordEvents, testId: 'LoginWidget_Link_Show_Hide_Password' }))));
    };
    return Password;
}(React.Component));
exports.default = Password;
//# sourceMappingURL=Password.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/Password/Password.js
// module id = 355
// module chunks = 8